<template>
  <div v-if="item">
    <h4>Запрос # {{ item.id }} / {{ item.bank.name }}</h4>
    <h5 class="text-success">Статус: {{ item.state }}</h5>
    <div class="row">
      <div class="col-12 col-md-6">
        <h5>
          {{ "loan_sum" | setText("Сумма кредита") }}:
          {{ item.loan_amount_desired | spaceBetweenNumber }} UZS
        </h5>
        <h5>
          {{ "loan_month" | setText("Срок кредита (месяц)") }}:
          {{ item.loan_term_desired | spaceBetweenNumber }}
        </h5>
        <h5>
          {{ "loan_reason" | setText("Причина кредита") }}:
          {{ item.loan_goal }}
        </h5>
        <h5>
          {{ "query_date" | setText("Дата запроса") }}}:
          {{ item.created_at | dateTimeFormat }}
        </h5>
        <h5>{{ "inn" | setText("ИНН") }}: {{ item.dealer_tin }}</h5>
        <h5>{{ "oked" | setText("ОКЭД") }}: {{ item.dealer_oked }}</h5>
      </div>
      <div class="col-12 col-md-6">
        <h5>
          {{ "director" | setText("Директор") }}:
          {{ item.dealer_director_name }}
        </h5>
        <h5>
          {{ "chief" | setText("Бухгалтер") }}:
          {{ item.dealer_chief_accountant_name }}
        </h5>
        <h5>{{ "bank" | setText("Банк") }}: {{ item.dealer_bank_name }}</h5>
        <h5>
          {{ "bank_number" | setText("Банк р/с") }}:
          {{ item.dealer_bank_account }}
        </h5>
        <h5>
          {{ "bank_inn" | setText("Банк ИНН") }}}: {{ item.dealer_bank_tin }}
        </h5>
      </div>
    </div>
    <hr />
    <component
      v-if="item"
      :is="item.bank.code"
      :data="item"
      v-model="value"
      @input="updateItem"
      :update="updateItem"
    />
  </div>
</template>

<script>
import { cardContent, toFormData, errorNotify } from "@/plugins/functions";

export default {
  components: {
    aab: () => import("@/components/Banks/aab"),
  },
  data: () => ({
    cardLink: "loans",
    item: null,
    value: {},
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardContent: cardContent,
    async updateItem() {
      this.$loading(true);
      return this.$http({
        method: "post",
        data: toFormData({ _method: "put", ...this.value }),
        url: `loans/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.item = response.data.data;
          return response.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style>
</style>
